import { memo } from "react";

import { BentoBoxCardsLayoutAPlaceholder } from "@react/sections/BentoBox/BentoBoxCards/BentoBoxCardsLayoutAPlaceholder.view";
import { BentoBoxCardsLayoutBPlaceholder } from "@react/sections/BentoBox/BentoBoxCards/BentoBoxCardsLayoutBPlaceholder.view";
import {
  type BentoBoxSectionSettings,
  BentoBoxLayout,
} from "@root/tablescape/state/bentoBox";
import { type TTailwindString, tw } from "classnames";

const styles = {
  base: tw("bg-background-primary"),
  wrapper: tw(
    "max-w-full",
    "sm:max-w-screen-sm",
    "md:max-w-screen-md",
    "mg:max-w-screen-mg",
    "lg:max-w-screen-lg",
    "xl:max-w-screen-xl",
    "mx-auto",
    "px-6",
    "py-12",
    "lg:px-12",
    "lg:py-20"
  ),
  content: tw(
    "xl:max-w-[995px]" as TTailwindString,
    "lg:max-w-[878px]" as TTailwindString,
    "mg:max-w-[645px]" as TTailwindString,
    "md:max-w-[595px]" as TTailwindString,
    "mb-7",
    "lg:mb-11",
    "animate-pulse"
  ),
  title: tw("mb-6", "text-primary"),
  subtitle1: tw("mb-2", "text-primary"),
  subtitle2: tw("text-secondary"),
  titleBlock: tw(
    "rounded",
    "bg-placeholder",
    "h-10",
    "md:h-14",
    "mb-2.5",
    "md:mb-3.5"
  ),
  subtitleBlock: tw(
    "rounded",
    "bg-placeholder",
    "h-6",
    "md:h-8",
    "mb-2",
    "md:mb-3.5"
  ),
  image: tw(
    "flex",
    "h-full",
    "w-full",
    "items-center",
    "justify-center",
    "rounded",
    "bg-placeholder"
  ),
  svg: tw("h-10", "w-10", "text-placeholder"),
};

const BentoBoxPlaceholderBase = ({
  cards,
  layout,
  subtitleText1,
  subtitleText2,
  theme,
  titleText,
}: BentoBoxSectionSettings) => {
  return (
    <div
      className={tw(
        "pointer-events-none",
        "box-border",
        "bg-background-primary",
        "pb-16",
        "mg:pb-24",
        "mg:pt-12"
      )}
      data-theme={theme}
    >
      <div className={styles.wrapper}>
        <div className={styles.content}>
          {titleText && (
            <>
              <div className={tw(styles.titleBlock, "w-full", "md:hidden")} />
              <div className={tw(styles.titleBlock, "w-5/6")} />
              <div className={tw(styles.titleBlock, "w-4/5")} />
              <div className={tw(styles.titleBlock, "w-full", "lg:hidden")} />
              <div className={tw(styles.titleBlock, "w-2/3", "lg:w-1/2")} />
            </>
          )}
          {subtitleText1 && (
            <div className={titleText ? tw("mt-10", "md:mt-12") : ""}>
              <div className={tw(styles.subtitleBlock, "w-4/5", "mg:hidden")} />
              <div
                className={tw(
                  styles.subtitleBlock,
                  "w-3/5",
                  "mb-5",
                  "md:w-1/3",
                  "md:mb-7",
                  "mg:w-full",
                  "max-w-[610px]" as TTailwindString
                )}
              />
            </div>
          )}
          {subtitleText2 && (
            <div
              className={tw(
                styles.subtitleBlock,
                "w-3/4",
                "md:w-3/5",
                "max-w-[450px]" as TTailwindString
              )}
            />
          )}
        </div>
        {layout === BentoBoxLayout.A && (
          <BentoBoxCardsLayoutAPlaceholder cards={cards} />
        )}
        {layout === BentoBoxLayout.B && (
          <BentoBoxCardsLayoutBPlaceholder cards={cards} />
        )}
      </div>
    </div>
  );
};

export const BentoBoxPlaceholder = memo(BentoBoxPlaceholderBase);
